import { render, staticRenderFns } from "./MiInversionForm.vue?vue&type=template&id=5f3831e0&scoped=true"
import script from "./MiInversionForm.vue?vue&type=script&lang=ts"
export * from "./MiInversionForm.vue?vue&type=script&lang=ts"
import style0 from "./MiInversionForm.vue?vue&type=style&index=0&id=5f3831e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3831e0",
  null
  
)

export default component.exports